import { Chip } from 'common/components/Chip';
import { Tooltip } from 'common/components/Tooltip';
import { IOfferEventSubscriptionStatus } from 'graphql/types';
import { getOfferEventSubscriptionStatusData } from 'offer/utils/offerEvent';

interface IProps {
    reason?: string;
    subscriptionStatus: IOfferEventSubscriptionStatus;
}

export const OfferEventSubscriptionStatusChip = ({
    reason,
    subscriptionStatus,
}: IProps) => {
    // Completed and Absent statuses are now handled by the OfferEventAttendanceChips component
    if (
        subscriptionStatus === IOfferEventSubscriptionStatus.Completed ||
        subscriptionStatus === IOfferEventSubscriptionStatus.Absent
    ) {
        return null;
    }

    const chipData = getOfferEventSubscriptionStatusData(subscriptionStatus);

    if (!chipData) return null;

    const { color, label } = chipData;

    const chip = (
        <Chip bgColor={color} key={subscriptionStatus} label={label} />
    );

    if (
        subscriptionStatus === IOfferEventSubscriptionStatus.Denied &&
        !!reason
    ) {
        return <Tooltip title={reason}>{chip}</Tooltip>;
    }

    return chip;
};
